import $ from "jquery";


export default function manufacturer() {




        $('.edv-services-link').click(function(e){
            e.preventDefault();
            let targetId = $(this).attr('href');
            let offset = $(window).width() > 992 ? 95 : 140;
            $('html, body').animate({
                scrollTop: $(targetId).offset().top - offset
            }, 0, function() {
                updateHighlight();
            });
        });


        function updateHighlight() {
            let scrollPos = $(window).scrollTop() + 300;

            $('.manufacturer-container').each(function() {
                let top = $(this).offset().top;
                let bottom = top + $(this).outerHeight();
                let id = '#' + $(this).attr('id');
                if (scrollPos >= top && scrollPos <= bottom) {
                    $('.edv-services-link[href="' + id + '"]').addClass('highlight');
                } else {
                    $('.edv-services-link[href="' + id + '"]').removeClass('highlight');
                }
            });
        }


        $(window).scroll(function() {
            updateHighlight();
        });


        updateHighlight();

    $('.accordion-body .edv-services-link').click(function(e) {
        let accordionCollapse = $(this).closest('.accordion-collapse');
        let accordionButton = accordionCollapse.siblings('.accordion-header').find('.accordion-button');
        accordionCollapse.removeClass('show');
        accordionButton.addClass('collapsed').attr('aria-expanded','false');



    });


}